import { useEffect, useState } from 'react'
import { TableFooter, TablePagination, Box, Badge, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Switch, Button, CircularProgress } from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles'
import {green, grey} from '@material-ui/core/colors'
import Typography from '@material-ui/core/Typography'
import MakeOrganization from '../MakeOrganization';
import MakeIcon from '@material-ui/icons/Add'
import Orgs from '../../services/organization'
import Auth from '../../services/auth'
import { getTemplates } from '../../services/whatsApp'
import Notify from '../Notify'
import StatusIcon from '@material-ui/icons/FiberManualRecord';
import { Edit as EditIcon, Delete as DeleteIcon, Publish as PublishIcon } from '@material-ui/icons'
import { MakeWhatsAppTemplate } from '../WhatsApp/MakeWhatsAppTemplate'
import { PublishTemplateModal } from '../WhatsApp/PublishTemplateModal'

import { Skeleton } from '@material-ui/lab';

const GreenSwitch = withStyles({
  switchBase: {
    color: grey[300],
    '&$checked': {
      color: green[500]
    },
    '&$checked + $track': {
      backgroundColor: green[500],
    }
  },
  checked: {},
  track: {}
})(Switch)

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

const StatusIndicator = ({ status }) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [stepStatus, setStepStatus] = useState('PENDING')

  const getColor = (stepStatus) => {
    console.log('getColor', stepStatus)
    switch (stepStatus) {
      case 'FAIL':
        return '#ff3b3b'; // Red for error
      case 'SUCCESS':
        return '#4caf50'; // Green for success
      case 'PENDING':
      case 'INPROGRESS':
        return '#ff9800'; // Yellow for warning
      default:
        return '#e0e0e0'; // Gray for unknown
    }
  };

  const statusSteps = ['connectWaba', 'subAccount', 'phoneAssignment', 'whatsAppSender', 'whatsAppTemplates']
  const statusLabels = {
    'connectWaba': 'Connecting WhatsApp Business Account',
    'subAccount': 'Creating Sub Account',
    'phoneAssignment': 'Assigning Phone Number',
    'whatsAppSender': 'Preparing WhatsApp Sender',
    'whatsAppTemplates': 'Creating WhatsApp Templates',
    'active': 'Active'
  }

  useEffect(() => {
    if (!status) {
      setStepStatus('UNREGISTERED')
      setCurrentStep(5)
    } else if (status.done) {
      console.log('status.done', status)
      setCurrentStep(5)
      setStepStatus('SUCCESS')
    } else {
      for (let i = statusSteps.length - 1; i > 0; i--) {
        if (status[statusSteps[i]] === 'PENDING') {
          continue
        }
    
        console.log('status', i, statusSteps[i], status[statusSteps[i]])
    
        setCurrentStep(i)
        setStepStatus(status[statusSteps[i]])
        break
      }
    }
  }, [])

  if (!status) {
    return (
      <Typography>
        <StatusIcon style={{fontSize: '12px', color: getColor(stepStatus)}} /> Unregistered
      </Typography>
    )
  }

  return (    
    <Typography>
      <StatusIcon style={{fontSize: '12px', color: getColor(stepStatus)}} /> {status.done ? 'Active' : statusLabels[statusSteps[currentStep]]}
    </Typography>
  );
};

export const WhatsAppTemplatesTable = (props) => {
  const [templates, setTemplates] = useState([])
  const [notify, setNotify] = useState({show: false})
  const [showMakeTemplate, setShowMakeTemplate] = useState(false)
  const [editTemplate, setEditTemplate] = useState(null)
  const [publishTemplate, setPublishTemplate] = useState(null)

  const onEditTemplate = (template) => {
    console.log('onEditTemplate', template)
    setEditTemplate(template)
  }

  const onPublishTemplate = (template) => {
    console.log('onPublishTemplate', template)
    setPublishTemplate(template)
  }

  const onCloseEditTemplate = (result) => {
    console.log('onCloseEditTemplate', result)
    if (result) {
      // then refresh the table
      getTemplates({ organizationId: props.organizationId })
        .then(result => {
          console.log('init.templates', result)
          setTemplates(result.data.templates)
        })
    }
    setEditTemplate(null)
  }

  const onClosePublishTemplate = (res) => {
    console.log('onClosePublishTemplate', res)
    setPublishTemplate(null)
    if (res.success) {
      setTimeout(() => {
        getTemplates({ organizationId: props.organizationId })
          .then(result => {
            console.log('init.templates', result)
            setTemplates(result.data.templates)
          })
      }, 1000)
    }
  }

  const onCloseMakeWhatsAppTemplate = (result) => {
    console.log('onCloseMakeWhatsAppTemplate', result)
    if (result) {
      // then refresh the table
      // delay to allow the template to be created
      setTimeout(() => {
        getTemplates({ organizationId: props.organizationId })
          .then(result => {
            console.log('init.templates', result)
            setTemplates(result.data.templates)
          })
      }, 1000)
    }
    setShowMakeTemplate(false)
  }

  useEffect(() => {
    console.log('WhatsAppTemplatesTable.init', props)
    getTemplates({ organizationId: props.organizationId })
      .then(result => {
        console.log('init.templates', result)
        setTemplates(result.data.templates)
      })
  }, [props.organizationId])

  const headers = [
    {
      label: 'Label',
      key: 'label'
    },
    {
      label: 'Action',
      key: 'action'
    },
    {
      label: 'Approval Status',
      key: 'status'
    },
    {
      label: 'Message',
      key: 'message'
    },
    {
      label: 'Language',
      key: 'language'
    },
    {
      label: 'Published',
      key: 'published'
    }
  ]
  const onNotifyClose = function () {
    setNotify({show: false})
  }

  const onSelect = function (id) {
    if (props.onSelect) {
      props.onSelect(id)
    }
  }

  return (
    <>
      {/* {promptStatusChange.show && <ConfirmStatusChange onClose={onConfirmStatusChange} active={!promptStatusChange.org.disabled} />}
      {promptDeleteOrg.show && <ConfirmDeleteOrganization onClose={onDeleteOrganization} organizationName={promptDeleteOrg.org.name} loading={promptDeleteOrg.loading} />} */}
      {notify.show && <Notify variant={notify.variant} onClose={onNotifyClose} message={notify.message} />}
      <Box mb={2} display="flex" justifyContent="flex-end">
        <Button onClick={() => setShowMakeTemplate(true)} variant="contained" color="primary">Add New Template</Button>
      </Box>
      <TableContainer component={Paper}>
        <Skeleton variant="rect" width="100%" height="100%" />
        <Table aria-label="Table of WhatsApp Templates">
          <TableHead>
            <TableRow>
              {headers.map(header => <TableCell key={header.key}>{header.label}</TableCell>)}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {
              templates.map(row => (
                  <TableRow key={row.id}>
                    {
                      headers
                        .map(header => {
                          switch (header.key) {
                            // case 'action':
                            //   return <TableCell key={`${row.id}_${header.key}`}>{row.action}</TableCell>
                            case 'status':
                              return <TableCell key={`${row.id}_${header.key}`}>
                                {row.status || 'Unpublished'}
                              </TableCell>
                            case 'text':
                              return <TableCell key={`${row.id}_${header.key}`}>{row.text}</TableCell>
                            case 'published':
                              return <TableCell key={`${row.id}_${header.key}`}>{row.published && row.status !== 'unsubmitted' ? 'Yes' : 'No'}</TableCell>
                            case 'label':
                              return <TableCell key={`${row.id}_${header.key}`}>
                                <Button onClick={() => onSelect(row.id)}>
                                  {row.label}
                                </Button>
                              </TableCell>
                            default:
                              return <TableCell key={`${row.id}_${header.key}`}>{row[header.key]}</TableCell>
                          }
                        })
                    }
                    <TableCell>
                      {/* action buttons - edit, delete, publish */}
                      <IconButton disabled={row.published} onClick={() => onEditTemplate(row)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton disabled={row.published}>
                        <DeleteIcon />
                      </IconButton>
                      <IconButton disabled={row.published && row.status !== 'unsubmitted'} onClick={() => onPublishTemplate(row)}>
                        <PublishIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
            }
          </TableBody>
        </Table>
      </TableContainer>

      { showMakeTemplate ? <MakeWhatsAppTemplate open organizationId={props.organizationId} countryCode={props.countryCode} handleClose={onCloseMakeWhatsAppTemplate} /> : null }
      { editTemplate ? <MakeWhatsAppTemplate open organizationId={props.organizationId} countryCode={props.countryCode} handleClose={onCloseEditTemplate} template={editTemplate} /> : null }
      { publishTemplate ? <PublishTemplateModal open={publishTemplate} onClose={onClosePublishTemplate} template={publishTemplate} organizationId={props.organizationId} /> : null }
    </>
  )
}